import styled from 'styled-components'
import { BLACK, GREEN_600 } from '../../styles/colors'

export const ValueText = styled.span`
  color: ${BLACK};
`

export const CheckContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background-color: ${GREEN_600};
  aspect-ratio: 1;
  width: 16px;
  height: 16px;
`

export const DashText = styled.span`
  color: ${BLACK};
`
